module.exports = __webpack_public_path__ + "img/NH_ST_kit.a65dfea7.png";